import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './styles.css'

/**
 * Ant Design 基础输入框（带防抖搜索）
 *
 * - 在用户停止输入 1s 后触发 `searchFun` 回调（防抖）
 * - 使用 antd Input，带清除与搜索图标前缀
 *
 * Props:
 * - searchFun: (event) => void  输入稳定后回调（原始 onChange 事件）
 * - placeholder?: string       占位提示
 * - 其余 props 透传给 antd Input
 */

export default function InputAntDef({ searchFun, placeholder, ...props }) {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const lastEvent = useRef(null)

  useEffect(() => {
    let timeoutId = null

    const debouncedChange = () => {
      if (lastEvent.current) {
        searchFun(lastEvent.current)
        lastEvent.current = null
      }
    }

    timeoutId = setTimeout(debouncedChange, 1000)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [value])

  const handleChange = event => {
    setValue(encodeURIComponent(event.target.value))
    lastEvent.current = event
  }
  return (
    <>
      <Input
        onChange={handleChange}
        className="Input_ant_def"
        allowClear
        placeholder={placeholder || t('application.searchName')}
        prefix={<SearchOutlined />}
        {...props}
      />
    </>
  )
}
